import styled from "styled-components";

export const ContainerCredenciais = styled.div`
  width: 100%;
  padding: 5rem 10rem 20rem 10rem;

  @media (max-width: 1024px) {
    padding: 5rem 5rem 25rem 5rem;
  }

  @media (max-width: 425px) {
    padding: 3rem 2rem 20rem 2rem;
  }

  .descricao {
    color: ${(props) => props.theme.colors.tertiary};
    line-height: 1.6;
    text-align: justify;
    max-width: 600px;
    margin-bottom: 4rem;
  }

  .content {
    max-width: 500px;
  }

  .info-box {
    background-color: ${(props) => props.theme.colors.background2};
    border-radius: 10px;
    padding: 2rem 0;
    margin-bottom: 3rem;

    .info-label {
      color: ${(props) => props.theme.colors.secondary};
      font-weight: 600;
      text-align: justify;
      margin-bottom: 0.5rem;
    }

    .info-value {
      color: ${(props) => props.theme.colors.tertiary};
      text-align: justify;
    }

    .info-motivo {
      margin-top: 1.5rem;
      padding-top: 1.5rem;
      border-top: 1px solid ${(props) => props.theme.colors.elements};
    }
  }

  .form-group {
    margin-bottom: 2rem;

    .label {
      color: ${(props) => props.theme.colors.tertiary};
      margin-bottom: 1rem;
      display: block;
      text-align: justify;
    }
  }

  .aviso {
    color: ${(props) => props.theme.colors.tertiary};
    line-height: 1.5;
    text-align: justify;
    margin-bottom: 3rem;
  }
`;

export const ContainerLoading = styled.div`
  width: 100%;
  padding: 5rem 10rem;
  min-height: 50vh;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 5rem 5rem;
  }

  .loading-content {
    .loading-text {
      color: ${(props) => props.theme.colors.tertiary};
      margin-top: 2rem;
      text-align: justify;
    }
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 1024px) {
    button {
      width: 100%;
    }
  }
`;
